import styled from 'styled-components';

const List = styled.ul`
	padding: 0;
	list-style-type: none;
`;

export default List;
